import { useContext, useEffect, useRef, useState } from "react";
import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Devices/Devices.css";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
import { LoadShortDate } from "../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../functions/LoadShortTime.js";
import Device from "./Device.jsx";
import { AppContext } from "../../../AppProvider.jsx";
import NavigationBar from "../../../navigation_components/NavigationBar.jsx";
import CustomerAdministratorSideBar from "../../../sidebar_components/CustomerAdministratorSideBar.jsx";
import { useNavigate } from "react-router-dom";
function DevicesTable({devicesSummary,access_token,logout}){
    const[showDeviceComponent,setShowDeviceComponent] = useState(false);
    const[deviceId,setDeviceId] = useState(null);
    const[serverUrl,setServerUrl] = useState(null);
    const[devicesSortType,setDevicesSortType] = useState('name-ascending');

    if(!Array.isArray(devicesSummary) || devicesSummary.length === 0) return(
            <div className="customer-administrator-loading-devices-mask">
                <div className="customer-administrator-loading-devices-mask-spinner"></div>
                <p>Loading devices, please wait...</p>
            </div>
    );
    return(
        <div className="customer-administrator-devices-table-container">
            <table className="customer-administrator-devices-table">
                <thead>
                    <tr id="customer-administrator-devices-table-header-row">
                        <th onClick={() =>{
                            if(devicesSortType === 'name-ascending') setDevicesSortType('name-descending');
                            else setDevicesSortType('name-ascending');
                        }}>Name</th>
                        <th>Date created</th>
                        <th>Time created</th>
                        <th>Subscription</th>
                        <th onClick={() =>{
                            if(devicesSortType === 'status-ascending') setDevicesSortType('status-descending');
                            else setDevicesSortType('status-ascending');
                        }}>Status</th>
                        <th onClick={() =>{
                            if(devicesSortType === 'customer-ascending') setDevicesSortType('customer-descending');
                            else setDevicesSortType('customer-ascending');
                        }}>Customer</th>
                    </tr>
                </thead>
                <tbody>
                    {[...devicesSummary].sort((a,b) =>{
                        if(devicesSortType === 'name-ascending') return a?.name?.localeCompare(b?.name);
                        else if(devicesSortType === 'name-descending') return b?.name?.localeCompare(a?.name);
                        else if(devicesSortType === 'status-ascending') return (a?.active? 'Active':'Inactive').localeCompare(b?.active? 'Active':'Inactive');
                        else if(devicesSortType === 'status-descending') return (b?.active? 'Active':'Inactive').localeCompare(a?.active? 'Active':'Inactive');
                        else if(devicesSortType === 'customer-ascending') return a?.customerName?.localeCompare(b?.customerName);
                        else if(devicesSortType === 'customer-descending') return b?.customerName?.localeCompare(a?.customerName);
                    }).map(deviceSummary => {
                        return (
                            <tr onClick={async () =>{
                                setDeviceId(deviceSummary.id);
                                setServerUrl(deviceSummary.serverUrl);
                                setShowDeviceComponent(true);
                            }} key={deviceSummary?.id}>
                                <td>{deviceSummary?.name}</td>
                                <td>{LoadShortDate(deviceSummary?.createdTime)}</td>
                                <td>{LoadShortTime(deviceSummary?.createdTime)}</td>
                                <td style={{color:`${deviceSummary?.subscription === 'ACTIVE'? 'green':deviceSummary?.subscription === 'GRACE'? 'darkorange':'red'}`}}>
                                    {deviceSummary?.subscription === 'ACTIVE'? 'Active':deviceSummary?.subscription === 'GRACE'? 'Grace':'Inactive'}
                                </td>
                                <td style={{color:`${deviceSummary?.active? 'green':'red'}`}}>{deviceSummary?.active? 'Active':'Inactive'}</td>
                                <td>{deviceSummary?.customerName || '_'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <Device
                deviceId={deviceId}
                serverUrl={serverUrl}
                access_token={access_token}
                showDeviceComponent={showDeviceComponent}
                setShowDeviceComponent={setShowDeviceComponent}
                logout={logout}
            />
        </div>
    );
}
const Devices = () =>{
    const {user,logout,customerIotProfile,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage} = useContext(AppContext);
    const [devicesSummary,setDevicesSummary] = useState([]);
    const logoutTimerRef = useRef(null);
    const navigate = useNavigate();
    
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/admin/${customerIotProfile?.id}/devices`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(Number(response.status) === 401) logout();
            else if(response.ok){
                const responseData = await response.json();
                setDevicesSummary(responseData);
            }
            else throw new Error(`Status code: ${response.status}`);
        }
        catch(error){
            console.error(error);
        }
    }
    useEffect(() =>{
        if(!user){
            logoutTimerRef.current = setTimeout(() =>{
                navigate('/');
                window.location.reload();
            },10);
            return;
        }
        else{
            if(logoutTimerRef.current){
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        }
        fetchDevicesSummary();
    },[]);
    return(
        <div className="customer-administrator-devices-page">
            <NavigationBar/>
            <div className="customer-administrator-devices-page-layout">
                <div>
                    <CustomerAdministratorSideBar/>
                </div>
                <div className="customer-administrator-devices-parent-container">
                    <div className="customer-administrator-devices-container">
                        <div className="customer-administrator-devices-header-container">
                            <h2>Devices</h2>
                            <div className="customer-administrator-devices-header-controls">
                                <button className="customer-administrator-refresh-devices-button" onClick={() => fetchDevicesSummary()}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {<DevicesTable
                            devicesSummary={devicesSummary}
                            access_token={user?.access_token}
                            logout={logout}
                            setShowBottomRightMessageBox={setShowBottomRightMessageBox}
                            setBottomRightMessageBoxMessage={setBottomRightMessageBoxMessage}
                        />}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Devices;